export function saveAs (data: Blob | string, fileName: string): void {
  const url = typeof data === 'string' ? data : URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  if (typeof data !== 'string') {
    setTimeout(() => URL.revokeObjectURL(url), 0)
  }
}
